(function () {
  var form = document.getElementById("ua-quote-form");
  if (!form) return;

  var endpoint =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/forms/submit";

  var formConfigEndpoint =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/forms/config/request-quote";

  var formConfig = null;

  var messageEl = document.getElementById("ua-quote-message");
  var successEl = document.getElementById("ua-quote-success");
  var successIdEl = document.getElementById("ua-quote-success-id");
  var submitAnotherBtn = document.getElementById("ua-quote-submit-another");
  var submitBtn = document.getElementById("ua-quote-submit");

  var productPreview = document.getElementById("ua-quote-product-preview");
  var productPreviewImage = document.getElementById("ua-quote-product-preview-image");
  var productPreviewName = document.getElementById("ua-quote-product-preview-name");
  var productPreviewSku = document.getElementById("ua-quote-product-preview-sku");
  var productPreviewBrand = document.getElementById("ua-quote-product-preview-brand");
  var productPreviewColor = document.getElementById("ua-quote-product-preview-color");

  var sourcePageInput = document.getElementById("ua-quote-source-page-url");

  var MAX_ATTACHMENT_COUNT = 10;
  var MAX_ATTACHMENT_SIZE_BYTES = 15 * 1024 * 1024;
  var MAX_TOTAL_ATTACHMENT_BYTES = 50 * 1024 * 1024;
  var ALLOWED_ATTACHMENT_PATTERN = /\.(ai|eps|pdf|svg|png|jpe?g|webp|psd|tiff?)$/i;

  function byId(id) {
    return document.getElementById(id);
  }

  function setValue(id, value) {
    var el = byId(id);
    if (!el) return;
    el.value = value == null ? "" : String(value);
  }

  function getValue(id) {
    var el = byId(id);
    return el ? String(el.value || "").trim() : "";
  }

  function getSelectedOptionText(id) {
    var el = byId(id);
    if (!el || !el.options || el.selectedIndex < 0) return "";

    var option = el.options[el.selectedIndex];
    return option ? String(option.textContent || "").trim() : "";
  }

  function getRadioValue(name) {
    var selected = form.querySelector('input[name="' + name + '"]:checked');
    return selected ? selected.value : "";
  }

  function getCheckedValues(name) {
    return Array.prototype.slice
      .call(form.querySelectorAll('input[name="' + name + '"]:checked'))
      .map(function (item) {
        return item.value;
      });
  }


  function getConfiguredField(fieldId) {
    var fields = formConfig && Array.isArray(formConfig.fields)
      ? formConfig.fields
      : [];

    return fields.find(function (field) {
      return String(field && field.id || "") === String(fieldId || "");
    }) || null;
  }

  function renderSelectOptions(select, options) {
    if (!select || !Array.isArray(options)) return;

    var currentValue = String(select.value || "");
    select.innerHTML = "";

    options.forEach(function (option) {
      if (!option || option.enabled === false) return;

      var node = document.createElement("option");
      node.value = String(option.value == null ? "" : option.value);
      node.textContent = String(
        option.label == null ? node.value : option.label
      );
      select.appendChild(node);
    });

    var stillExists = Array.prototype.some.call(
      select.options,
      function (option) {
        return option.value === currentValue;
      }
    );

    if (stillExists) {
      select.value = currentValue;
    } else if (select.options.length) {
      select.selectedIndex = 0;
    }
  }

  function renderCheckboxOptions(container, name, options) {
    if (!container || !Array.isArray(options)) return;

    var selected = {};
    getCheckedValues(name).forEach(function (value) {
      selected[String(value)] = true;
    });

    container.innerHTML = "";

    options.forEach(function (option) {
      if (!option || option.enabled === false) return;

      var label = document.createElement("label");
      label.className = "ua-choice-grid__item";

      var input = document.createElement("input");
      input.type = "checkbox";
      input.name = name;
      input.value = String(option.value == null ? "" : option.value);
      input.checked = !!selected[input.value];

      var span = document.createElement("span");
      span.textContent = String(
        option.label == null ? input.value : option.label
      );

      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function setConfiguredVisibility(wrapper, visible) {
    if (!wrapper) return;

    wrapper.hidden = !visible;

    if (visible) {
      wrapper.removeAttribute("aria-hidden");
      wrapper.style.removeProperty("display");
    } else {
      wrapper.setAttribute("aria-hidden", "true");
      wrapper.style.setProperty("display", "none", "important");
    }
  }

  function fieldIsVisibleForGeneralMode(field) {
    if (!field) return false;

    var modes = Array.isArray(field.showInModes)
      ? field.showInModes
      : [];

    return (
      field.visible !== false &&
      (!modes.length || modes.indexOf("general") >= 0)
    );
  }

  function updateConfiguredLabel(wrapper, elementId, field, required) {
    if (!wrapper || !field || !field.label) return;

    var label =
      wrapper.querySelector('label[for="' + elementId + '"]') ||
      wrapper.querySelector("legend");

    if (!label) return;

    label.textContent =
      String(field.label) + (required ? " *" : "");
  }

  function applyConfiguredField(fieldId, elementId) {
    var field = getConfiguredField(fieldId);
    var element = byId(elementId);

    if (!field || !element) return;

    var wrapper =
      element.closest(".ua-field") ||
      element.closest("fieldset") ||
      element.parentElement;

    var visible = fieldIsVisibleForGeneralMode(field);
    var enabled = field.enabled !== false;
    var required = visible && enabled && field.required === true;

    setConfiguredVisibility(wrapper, visible);

    element.disabled = !visible || !enabled;
    element.required = required;
    element.setAttribute(
      "aria-required",
      required ? "true" : "false"
    );

    if ("placeholder" in element) {
      element.placeholder = String(field.placeholder || "");
    }

    updateConfiguredLabel(wrapper, elementId, field, required);
  }

  function applyConfiguredRadioGroup(fieldId, name) {
    var field = getConfiguredField(fieldId);
    var radios = form.querySelectorAll(
      'input[type="radio"][name="' + name + '"]'
    );

    if (!field || !radios.length) return;

    var first = radios[0];
    var wrapper =
      first.closest("fieldset") ||
      first.closest(".ua-field") ||
      first.parentElement;

    var visible = fieldIsVisibleForGeneralMode(field);
    var enabled = field.enabled !== false;

    setConfiguredVisibility(wrapper, visible);

    radios.forEach(function (radio) {
      radio.disabled = !visible || !enabled;
      radio.required = false;
    });

    if (wrapper && field.label) {
      var legend = wrapper.querySelector("legend");
      if (legend) legend.textContent = String(field.label);
    }
  }

  function applyConfiguredCheckboxField(fieldId, elementId) {
    var field = getConfiguredField(fieldId);
    var element = byId(elementId);

    if (!field || !element) return;

    var wrapper =
      element.closest(".ua-consent") ||
      element.closest(".ua-field") ||
      element.parentElement;

    var visible = fieldIsVisibleForGeneralMode(field);
    var enabled = field.enabled !== false;
    var required = visible && enabled && field.required === true;

    setConfiguredVisibility(wrapper, visible);

    element.disabled = !visible || !enabled;
    element.required = required;
    element.setAttribute(
      "aria-required",
      required ? "true" : "false"
    );

    var text = wrapper ? wrapper.querySelector("span") : null;
    if (text && field.label) {
      text.textContent =
        String(field.label) + (required ? " *" : "");
    }
  }

  function applyConfiguredOptions() {
    var selectMappings = [
      ["decorationMethod", "ua-quote-decoration-method"],
      ["artworkStatus", "ua-quote-artwork-status"]
    ];

    selectMappings.forEach(function (mapping) {
      var field = getConfiguredField(mapping[0]);
      var select = byId(mapping[1]);

      if (!field || !select) return;

      if (Array.isArray(field.options)) {
        renderSelectOptions(select, field.options);
      }

      applyConfiguredField(mapping[0], mapping[1]);
    });

    var fieldMappings = [
      ["name", "ua-quote-name"],
      ["organization", "ua-quote-organization"],
      ["email", "ua-quote-email"],
      ["phone", "ua-quote-phone"],
      ["productName", "ua-quote-product-name"],
      ["manufacturerSku", "ua-quote-manufacturer-sku"],
      ["manufacturer", "ua-quote-manufacturer-brand"],
      ["selectedColor", "ua-quote-selected-color"],
      ["estimatedQuantity", "ua-quote-estimated-quantity"],
      ["neededByDate", "ua-quote-needed-by-date"],
      ["artworkFiles", "ua-quote-artwork-files"],
      ["projectNotes", "ua-quote-project-notes"]
    ];

    fieldMappings.forEach(function (mapping) {
      applyConfiguredField(mapping[0], mapping[1]);
    });

    applyConfiguredRadioGroup(
      "preferredContactMethod",
      "preferredContactMethod"
    );

    applyConfiguredCheckboxField(
      "consent",
      "ua-quote-consent"
    );

    var printField = getConfiguredField("printLocations");
    var printContainer = form.querySelector(
      '.ua-choice-grid.ua-choice-grid--checkbox'
    );

    if (printField && printContainer) {
      if (Array.isArray(printField.options)) {
        renderCheckboxOptions(
          printContainer,
          "printLocations",
          printField.options
        );
      }

      var printWrapper = printContainer.closest(".ua-field");
      var printVisible = fieldIsVisibleForGeneralMode(printField);
      var printEnabled = printField.enabled !== false;

      if (printWrapper) {
        setConfiguredVisibility(printWrapper, printVisible);

        var printLegend =
          printWrapper.querySelector("legend") ||
          printWrapper.querySelector(".ua-field__label");

        if (printLegend && printField.label) {
          printLegend.textContent = String(printField.label);
        }
      }

      printContainer
        .querySelectorAll('input[name="printLocations"]')
        .forEach(function (input) {
          input.disabled = !printVisible || !printEnabled;
        });
    }
  }

  function applyConfiguredContent() {
    if (!formConfig || !formConfig.content) return;

    var content = formConfig.content;

    var title = document.querySelector(".ua-quote-main__title");
    var intro = document.querySelector(".ua-quote-main__intro");
    var submit = byId("ua-quote-submit");
    var consentText = document.querySelector(
      ".ua-consent > span"
    );
    var successHeading = document.querySelector(
      "#ua-quote-success h3"
    );
    var successText = document.querySelector(
      "#ua-quote-success p"
    );

    if (title && content.heading) {
      title.textContent = content.heading;
    }

    if (intro && content.subheading) {
      intro.textContent = content.subheading;
    }

    if (submit && content.submitLabel) {
      submit.textContent = content.submitLabel;
    }

    if (consentText && content.consentText) {
      consentText.textContent = content.consentText + " *";
    }

    if (successHeading && content.successHeading) {
      successHeading.textContent = content.successHeading;
    }

    if (successText && content.successText) {
      successText.textContent = content.successText;
    }
  }

  function loadFormConfiguration() {
    return fetch(formConfigEndpoint, {
      method: "GET",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (payload) {
        formConfig =
          payload && payload.data
            ? payload.data
            : null;

        if (!formConfig) return;

        applyConfiguredContent();
        applyConfiguredOptions();
        updateArtworkUploadRequirement();

        window.requestAnimationFrame(function () {
          applyConfiguredOptions();
        });
      })
      .catch(function (error) {
        console.warn(
          "[Unisource RFQ] Unable to load form configuration.",
          error
        );
      });
  }

  function showMessage(text, type) {
    if (!messageEl) return;

    messageEl.textContent = text || "";
    messageEl.className = "ua-quote-message";

    if (type === "error") {
      messageEl.classList.add("is-error");
    } else if (type === "success") {
      messageEl.classList.add("is-success");
    }

    messageEl.classList.remove("is-hidden");

    if (text) {
      messageEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function clearMessage() {
    if (!messageEl) return;
    messageEl.textContent = "";
    messageEl.className = "ua-quote-message is-hidden";
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  }

  function extractBrandFromProductName(productName) {
    var text = String(productName || "").trim();

    if (!text) return "";

    if (text.indexOf("|") >= 0) {
      var parts = text.split("|");
      return String(parts[parts.length - 1] || "").trim();
    }

    return "";
  }

  function cleanProductName(productName) {
    var text = String(productName || "").trim();

    if (!text) return "";

    if (text.indexOf("|") >= 0) {
      return String(text.split("|")[0] || "").trim();
    }

    return text;
  }

  function hydrateProductPreview() {
    var productName = getValue("ua-quote-product-name");
    var productId = getValue("ua-quote-product-id");
    var manufacturerSku = getValue("ua-quote-manufacturer-sku");
    var manufacturerBrand = getValue("ua-quote-manufacturer-brand");
    var selectedStyleId = getValue("ua-quote-selected-style-id");
    var selectedColor = getValue("ua-quote-selected-color");
    var productImageUrl = getValue("ua-quote-product-image-url");

    var hasAnyProductData = !!(
      productName ||
      productId ||
      manufacturerSku ||
      manufacturerBrand ||
      selectedStyleId ||
      selectedColor ||
      productImageUrl
    );

    if (!hasAnyProductData) {
      if (productPreview) productPreview.classList.add("is-hidden");
      return;
    }

    if (productPreviewName) {
      productPreviewName.textContent = productName || "Selected product";
    }

    if (productPreviewSku) {
      productPreviewSku.textContent = manufacturerSku || "—";
    }

    if (productPreviewBrand) {
      productPreviewBrand.textContent = manufacturerBrand || "—";
    }

    if (productPreviewColor) {
      productPreviewColor.textContent = selectedColor || "—";
    }

    if (productPreviewImage) {
      if (productImageUrl) {
        productPreviewImage.src = productImageUrl;
        productPreviewImage.alt = productName
          ? productName + " product preview"
          : "Product preview";
        productPreviewImage.style.display = "";
      } else {
        productPreviewImage.removeAttribute("src");
        productPreviewImage.style.display = "none";
      }
    }

    if (productPreview) {
      productPreview.classList.remove("is-hidden");
    }
  }

  function hydrateFromQuery() {
    var params = new URLSearchParams(window.location.search);

    var rawProductName = params.get("productName") || "";
    var brandFromProductName = extractBrandFromProductName(rawProductName);
    var cleanName = cleanProductName(rawProductName);

    setValue("ua-quote-product-id", params.get("productId"));
    setValue("ua-quote-product-name", cleanName);
    setValue("ua-quote-manufacturer-sku", params.get("manufacturerSku"));
    setValue(
      "ua-quote-manufacturer-brand",
      params.get("manufacturer") ||
      params.get("manufacturerBrand") ||
      params.get("brand") ||
      brandFromProductName
    );
    setValue("ua-quote-selected-style-id", params.get("selectedStyleId"));
    setValue("ua-quote-selected-color", params.get("selectedColor"));
    setValue("ua-quote-product-image-url", params.get("productImageUrl"));
    setValue("ua-quote-estimated-quantity", params.get("quantity"));
    setValue("ua-quote-source-product-url", params.get("sourceProductUrl"));

    hydrateProductPreview();
  }

  function getArtworkFilesInput() {
    return byId("ua-quote-artwork-files");
  }

  function getArtworkFiles() {
    var input = getArtworkFilesInput();
    if (!input || !input.files) return [];

    return Array.prototype.slice.call(input.files);
  }

  function isArtworkUploadRequired() {
    var status = getValue("ua-quote-artwork-status");

    return (
      status === "artwork-ready" ||
      status === "ready-to-send" ||
      status === "reference-only" ||
      status === "updating-existing-artwork" ||
      status === "updating-existing-art"
    );
  }

  function updateArtworkUploadRequirement() {
    var input = getArtworkFilesInput();
    var requiredMarker = byId("ua-quote-artwork-files-required");
    var help = byId("ua-quote-artwork-files-help");

    var required = isArtworkUploadRequired();

    if (input) {
      input.required = required;
      input.setAttribute("aria-required", required ? "true" : "false");
    }

    if (requiredMarker) {
      requiredMarker.hidden = !required;
    }

    if (help) {
      help.textContent = required
        ? "Please upload your artwork or reference file for the selected artwork status. Accepted: AI, EPS, PDF, SVG, PNG, JPG, JPEG, WEBP, PSD, TIFF. Maximum 10 files, 15 MB each, 50 MB combined."
        : "Optional. Accepted: AI, EPS, PDF, SVG, PNG, JPG, JPEG, WEBP, PSD, TIFF. Maximum 10 files, 15 MB each, 50 MB combined.";
    }
  }

  function validateArtworkFiles() {
    var files = getArtworkFiles();

    if (isArtworkUploadRequired() && files.length === 0) {
      return "Please upload your artwork or reference file.";
    }

    if (files.length === 0) {
      return "";
    }

    if (files.length > MAX_ATTACHMENT_COUNT) {
      return "Please upload a maximum of " + MAX_ATTACHMENT_COUNT + " files.";
    }

    var totalSize = 0;

    for (var i = 0; i < files.length; i += 1) {
      var file = files[i];
      var fileName = String(file.name || "");
      var fileSize = Number(file.size || 0);

      totalSize += fileSize;

      if (!ALLOWED_ATTACHMENT_PATTERN.test(fileName)) {
        return "Unsupported file type. Accepted: AI, EPS, PDF, SVG, PNG, JPG, JPEG, WEBP, PSD, TIF, TIFF.";
      }

      if (fileSize <= 0) {
        return "One selected file appears to be empty. Please check your upload.";
      }

      if (fileSize > MAX_ATTACHMENT_SIZE_BYTES) {
        return "Each file must be 15 MB or smaller.";
      }
    }

    if (totalSize > MAX_TOTAL_ATTACHMENT_BYTES) {
      return "Combined attachments must be 50 MB or smaller.";
    }

    return "";
  }

  function validateForm() {
    var name = byId("ua-quote-name");
    var organization = byId("ua-quote-organization");
    var email = byId("ua-quote-email");
    var phone = byId("ua-quote-phone");
    var quantity = byId("ua-quote-estimated-quantity");
    var artworkStatus = byId("ua-quote-artwork-status");
    var artworkFilesInput = getArtworkFilesInput();

    if (name && !String(name.value || "").trim()) {
      name.focus();
      return "Please enter your name.";
    }

    if (organization && !String(organization.value || "").trim()) {
      organization.focus();
      return "Please enter your school, organization, or company.";
    }

    if (email && !String(email.value || "").trim()) {
      email.focus();
      return "Please enter your email address.";
    }

    if (email && !isValidEmail(email.value)) {
      email.focus();
      return "Please enter a valid email address.";
    }

    if (phone && !String(phone.value || "").trim()) {
      phone.focus();
      return "Please enter your phone number.";
    }

    if (quantity && !String(quantity.value || "").trim()) {
      quantity.focus();
      return "Please enter your estimated quantity.";
    }

    if (artworkStatus && !String(artworkStatus.value || "").trim()) {
      artworkStatus.focus();
      return "Please select the artwork status.";
    }

    var artworkFileError = validateArtworkFiles();
    if (artworkFileError) {
      if (artworkFilesInput) artworkFilesInput.focus();
      return artworkFileError;
    }

    var consent = byId("ua-quote-consent");
    if (consent && !consent.checked) {
      consent.focus();
      return "Please confirm the consent checkbox before submitting.";
    }

    return "";
  }

  function buildPayload() {
    var rawProductName = getValue("ua-quote-product-name");
    var productName = cleanProductName(rawProductName);
    var manufacturerBrand =
      getValue("ua-quote-manufacturer-brand") ||
      extractBrandFromProductName(rawProductName);

    var artworkStatusCode = getValue("ua-quote-artwork-status");
    var artworkStatusLabel = getSelectedOptionText("ua-quote-artwork-status");

    return {
      formType: "quote",
      name: getValue("ua-quote-name"),
      organization: getValue("ua-quote-organization"),
      email: getValue("ua-quote-email"),
      phone: getValue("ua-quote-phone"),
      preferredContactMethod: getRadioValue("preferredContactMethod"),

      productName: productName,
      productId: getValue("ua-quote-product-id"),
      manufacturerSku: getValue("ua-quote-manufacturer-sku"),
      manufacturer: manufacturerBrand,
      brand: manufacturerBrand,
      manufacturerBrand: manufacturerBrand,
      manufacturerName: manufacturerBrand,
      selectedStyleId: getValue("ua-quote-selected-style-id"),
      selectedColor: getValue("ua-quote-selected-color"),
      estimatedQuantity: getValue("ua-quote-estimated-quantity"),
      quantity: getValue("ua-quote-estimated-quantity"),
      neededByDate: getValue("ua-quote-needed-by-date"),
      productImageUrl: getValue("ua-quote-product-image-url"),
      sourceProductUrl: getValue("ua-quote-source-product-url"),

      decorationMethod: getValue("ua-quote-decoration-method"),
      artworkStatus: artworkStatusCode,
      artworkStatusCode: artworkStatusCode,
      artworkStatusLabel: artworkStatusLabel,
      printLocations: getCheckedValues("printLocations"),
      projectNotes: getValue("ua-quote-project-notes"),
      notes: getValue("ua-quote-project-notes"),

      consent: !!(byId("ua-quote-consent") && byId("ua-quote-consent").checked),
      sourcePageUrl: getValue("ua-quote-source-page-url") || window.location.href.split("?")[0],
      companyWebsite: getValue("ua-quote-company-website")
    };
  }

  function buildSubmissionBody(payload) {
    var files = getArtworkFiles();

    if (!files.length) {
      return {
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      };
    }

    var formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    files.forEach(function (file) {
      formData.append("artworkFiles", file, file.name);
    });

    return {
      body: formData,
      headers: {
        Accept: "application/json"
      }
    };
  }

  function getServerErrorMessage(data, fallback) {
    var serverMessage =
      data && (data.message || data.error)
        ? data.message || data.error
        : fallback || "We could not submit your request.";

    if (data && data.fields && typeof data.fields === "object") {
      var fieldMessages = Object.keys(data.fields)
        .map(function (field) {
          return data.fields[field];
        })
        .filter(Boolean);

      if (fieldMessages.length) {
        serverMessage = fieldMessages.join(" ");
      }
    }

    if (data && Array.isArray(data.errors) && data.errors.length) {
      var errorMessages = data.errors
        .map(function (item) {
          if (typeof item === "string") return item;
          if (item && typeof item === "object") {
            return item.message || item.error || item.reason || "";
          }
          return "";
        })
        .filter(Boolean);

      if (errorMessages.length) {
        serverMessage = errorMessages.join(" ");
      }
    }

    return serverMessage;
  }

  function disableSubmit(state) {
    if (!submitBtn) return;

    var configuredSubmitLabel =
      formConfig &&
      formConfig.content &&
      formConfig.content.submitLabel
        ? formConfig.content.submitLabel
        : "Submit Quote Request";

    submitBtn.disabled = !!state;
    submitBtn.textContent = state
      ? "Submitting..."
      : configuredSubmitLabel;
  }

  function showSuccess(submissionId) {
    form.classList.add("is-hidden");
    clearMessage();

    if (successIdEl) {
      successIdEl.textContent = submissionId || "Submitted successfully";
    }

    if (successEl) {
      successEl.classList.remove("is-hidden");
      successEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function resetForAnother() {
    form.reset();

    setValue("ua-quote-product-id", "");
    setValue("ua-quote-product-name", "");
    setValue("ua-quote-manufacturer-sku", "");
    setValue("ua-quote-manufacturer-brand", "");
    setValue("ua-quote-selected-style-id", "");
    setValue("ua-quote-selected-color", "");
    setValue("ua-quote-product-image-url", "");
    setValue("ua-quote-source-product-url", "");

    if (productPreviewImage) {
      productPreviewImage.removeAttribute("src");
    }

    if (productPreview) {
      productPreview.classList.add("is-hidden");
    }

    if (successEl) {
      successEl.classList.add("is-hidden");
    }

    form.classList.remove("is-hidden");
    clearMessage();
    window.scrollTo({ top: 0, behavior: "smooth" });

    updateArtworkUploadRequirement();
  }

  if (sourcePageInput) {
    sourcePageInput.value = window.location.href.split("?")[0];
  }

  hydrateFromQuery();
  updateArtworkUploadRequirement();
  loadFormConfiguration();

  var artworkStatusEl = byId("ua-quote-artwork-status");
  if (artworkStatusEl) {
    artworkStatusEl.addEventListener("change", updateArtworkUploadRequirement);
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    clearMessage();

    var validationMessage = validateForm();
    if (validationMessage) {
      showMessage(validationMessage, "error");
      return;
    }

    var payload = buildPayload();
    var submissionBody = buildSubmissionBody(payload);

    disableSubmit(true);

    fetch(endpoint, {
      method: "POST",
      headers: submissionBody.headers,
      body: submissionBody.body
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            data = {
              rawResponse: text
            };
          }

          if (!response.ok) {
            throw new Error(
              getServerErrorMessage(
                data,
                "We could not submit your request."
              )
            );
          }

          return data;
        });
      })
      .then(function (data) {
        showSuccess(
          data.submissionId ||
          data.reference ||
          data.referenceNumber ||
          data.id ||
          ""
        );
      })
      .catch(function (error) {
        showMessage(
          error && error.message
            ? error.message
            : "We could not submit your request.",
          "error"
        );
      })
      .finally(function () {
        disableSubmit(false);
      });
  });

  if (submitAnotherBtn) {
    submitAnotherBtn.addEventListener("click", function () {
      resetForAnother();
    });
  }
})();